import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Greeting — top-of-page hello + sub copy that adapts to scenario.
 * scenario: 'active' | 'calm' | 'firstrun'
 * posting: true for the Scheduler (posting) plan — firstrun sub swaps to
 * the two-step Scheduler copy instead of the three-step AI-plan one
 * (owner decision 2026-09-09, dashboard setup card redesign).
 */
function greetingFor(scenario, name, posting, t) {
  const who = name || t('greeting.defaultName');
  if (scenario === 'firstrun') {
    return {
      head: <>{t('greeting.welcomeLead')} <span className="grad-text">{who}</span>.</>,
      sub: t(posting ? 'greeting.firstrunSubPosting' : 'greeting.firstrunSub'),
    };
  }
  if (scenario === 'calm') return { head: <>{t('greeting.goodDayLead')} <span className="grad-text">{who}</span>.</>, sub: t('greeting.calmSub') };
  return { head: <>{t('greeting.helloLead')} <span className="grad-text">{who}</span>.</>, sub: t('greeting.activeSub') };
}

export default function Greeting({ scenario = 'calm', name, posting = false, children }) {
  const { t } = useTranslation();
  const { head, sub } = greetingFor(scenario, name, posting, t);
  return (
    <div className="dash-greet">
      <h1>{head}</h1>
      <p>{sub}</p>
      {children}
    </div>
  );
}
